/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyDescriptionDto } from '../../models/company-description-dto';

export interface GetCompanyDescription$Params {

/**
 * the customer technical id
 */
  customerId: number;
}

export function getCompanyDescription(http: HttpClient, rootUrl: string, params: GetCompanyDescription$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyDescriptionDto>> {
  const rb = new RequestBuilder(rootUrl, getCompanyDescription.PATH, 'get');
  if (params) {
    rb.path('customerId', params.customerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CompanyDescriptionDto>;
    })
  );
}

getCompanyDescription.PATH = '/customers/{customerId}/company-description';
